
export default class PartitionProfile {
    constructor(partition_id, profile_id) {
        this.profile_id = profile_id
        this.partition_id = partition_id
        this.content = null
        this.title = null
    }
}
